import React from 'react'
import styled from '@emotion/styled'
import {SplitBookingOfferInfo} from 'components/Offer/types'
import {Hotel} from 'modules/sapiSearch/slice'

import {cssTheme} from '@vio/atlas/themes'
import {SearchOffer} from '@vio/core/src/offer/types/SearchOffer'

import {RoomLabels} from '../RoomLabels'
import {SplitBookingRoomLabels} from '../SplitBookingRoomLabels/SplitBookingRoomLabels'

const RoomLabelsWrapper = styled.span`
  margin: ${cssTheme.layout.spacing.s100} 0 0 0;
  ${cssTheme.typography.bodyXS};
`

const SplitBookingRoomLabelsWrapper = styled.div`
  margin: ${cssTheme.layout.spacing.s100} 0 0 0;
  ${cssTheme.typography.bodyXS};
`

interface MainProps {
  isSplitBooking?: never
  hasRoomLabels: boolean
  splitBookingOffers?: never
  offer: SearchOffer
  hotelId: Hotel['objectID']
}

interface SplitBookingProps {
  isSplitBooking: true
  hasRoomLabels: boolean
  splitBookingOffers: SplitBookingOfferInfo[]
  offer?: never
  hotelId?: Hotel['objectID']
}

export const RoomLabelsComponent: React.FC<MainProps | SplitBookingProps> = ({
  isSplitBooking,
  splitBookingOffers,
  offer,
  hasRoomLabels = true,
  hotelId
}) => {
  if (!hasRoomLabels) {
    return null
  }

  if (isSplitBooking && splitBookingOffers?.length) {
    return (
      <SplitBookingRoomLabelsWrapper>
        <SplitBookingRoomLabels offers={splitBookingOffers} hotelId={hotelId} />
      </SplitBookingRoomLabelsWrapper>
    )
  }

  return (
    <RoomLabelsWrapper>
      <RoomLabels offer={offer} />
    </RoomLabelsWrapper>
  )
}
